import { apiPost, apiPatch } from "./client";

export function postContact(data) {
  return apiPost("/contacts/", data);
}

export function patchContact(data) {
  return apiPatch("/contacts/", data);
}

export function postContactRole(data) {
  return apiPost("/contactroles/", data);
}
